export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["विवादित स्तंभ"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["रीसेट करें"])}
}